import React, { useState } from "react";
import * as Accordion from "@radix-ui/react-accordion";
import Link from "next/link";

const accordionRootClasses = `
lg:w-[1228px] w-[90%] rounded-lg bg-brand-slate flex flex-col h-[full]
`;

const FAQPersonalPricing = () => {
  const [isQ1Open, setIsQ1Open] = useState(false);
  const [isQ2Open, setIsQ2Open] = useState(false);
  const [isQ3Open, setIsQ3Open] = useState(false);
  const [isQ4Open, setIsQ4Open] = useState(false);
  const [isQ5Open, setIsQ5Open] = useState(false);

  return (
    <>
      <div className="flex flex-col w-full items-center justify-center lg:mt-10 -mt-10">
        <p className="lg:text-6xl text-3xl lg:w-full w-[80%] text-center font-bold">
          Frequently asked questions
        </p>
        <Accordion.Root className={accordionRootClasses + "mt-10"} type="multiple">
          <Accordion.Item
            value="item-1"
            className="overflow-hidden bg-brand-slate first:mt-0 first:rounded-lg last:rounded-lg cursor-pointer w-full hover:bg-brand-slate/40"
          >
            <Accordion.Trigger
              className="
                            group flex flex-1 lg:h-[52px] h-[80px] items-center 
                            justify-between px-5 text-[15px]
                            w-full mt-0
                            hover:bg-brand-slate/40"
              onClick={() => setIsQ1Open(!isQ1Open)}
            >
              <div className="flex flex-col w-[50px] items-start mr-2">
                {isQ1Open ? (
                  <span
                    className="icon-[ic--baseline-minus]"
                    style={{ width: "2rem", height: "2rem" }}
                  ></span>
                ) : (
                  <span
                    className="icon-[ic--baseline-plus]"
                    style={{ width: "2rem", height: "2rem" }}
                  ></span>
                )}
              </div>
              <div className="flex w-full">
                <p className="font-bold text-start">What payment options are supported?</p>
              </div>
            </Accordion.Trigger>

            <Accordion.Content
              className="
                            overflow-hidden bg-brand-slate text-[15px] text-white data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown"
            >
              <div className="flex flex-1">
                <div className="flex w-full">
                  <p className="text-start ml-20 lg:w-[1120px] w-[70%]">
                    On desktop we support Paypal & Stripe. On mobile all purchases are handled by
                    the respective app stores.
                  </p>
                </div>
              </div>
            </Accordion.Content>
          </Accordion.Item>
        </Accordion.Root>

        <Accordion.Root className={accordionRootClasses + "mt-5"} type="multiple">
          <Accordion.Item
            value="item-1"
            className="overflow-hidden bg-brand-slate first:mt-0 first:rounded-lg last:rounded-lg cursor-pointer w-full hover:bg-brand-slate/40"
          >
            <Accordion.Trigger
              className="
                            group flex flex-1 lg:h-[52px] h-[80px] items-center 
                            justify-between px-5 text-[15px]
                            w-full mt-0
                            hover:bg-brand-slate/40"
              onClick={() => setIsQ2Open(!isQ2Open)}
            >
              <div className="flex flex-col w-[50px] items-start mr-2">
                {isQ2Open ? (
                  <span
                    className="icon-[ic--baseline-minus]"
                    style={{ width: "2rem", height: "2rem" }}
                  ></span>
                ) : (
                  <span
                    className="icon-[ic--baseline-plus]"
                    style={{ width: "2rem", height: "2rem" }}
                  ></span>
                )}
              </div>
              <div className="flex w-full">
                <p className="font-bold text-start">Why should I redact my social media content?</p>
              </div>
            </Accordion.Trigger>

            <Accordion.Content
              className="
                            overflow-hidden bg-brand-slate text-[15px] text-white data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown"
            >
              <div className="flex flex-1">
                <div className="flex w-full">
                  <p className="text-start ml-20 lg:w-[1120px] w-[70%]">
                    Data brokers, scammers and large corporations are processing and selling your
                    data on a scale that was not possible a few years ago. No one who is looking
                    through your old posts from a 5 years ago is up to anything good.
                  </p>
                </div>
              </div>
            </Accordion.Content>
          </Accordion.Item>
        </Accordion.Root>

        <Accordion.Root className={accordionRootClasses + "mt-5"} type="multiple">
          <Accordion.Item
            value="item-1"
            className="overflow-hidden bg-brand-slate first:mt-0 first:rounded-lg last:rounded-lg cursor-pointer w-full hover:bg-brand-slate/40"
          >
            <Accordion.Trigger
              className="
                            group flex flex-1 lg:h-[52px] h-[80px] items-center 
                            justify-between px-5 text-[15px]
                            w-full mt-0
                            hover:bg-brand-slate/40"
              onClick={() => setIsQ3Open(!isQ3Open)}
            >
              <div className="flex flex-col w-[50px] items-start mr-2">
                {isQ3Open ? (
                  <span
                    className="icon-[ic--baseline-minus]"
                    style={{ width: "2rem", height: "2rem" }}
                  ></span>
                ) : (
                  <span
                    className="icon-[ic--baseline-plus]"
                    style={{ width: "2rem", height: "2rem" }}
                  ></span>
                )}
              </div>
              <div className="flex w-full">
                <p className="font-bold text-start">
                  Does redact collect any personal information?
                </p>
              </div>
            </Accordion.Trigger>

            <Accordion.Content
              className="
                            overflow-hidden bg-brand-slate text-[15px] text-white data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown"
            >
              <div className="flex flex-1">
                <div className="flex w-full">
                  <p className="text-start ml-20 lg:w-[1120px] w-[70%]">
                    Redact does not collect, store or monitor any personal data outside of email
                    address used for account creation & billing details via our payment processors.
                    We are currently looking to support privacy friendly payment methods.
                  </p>
                </div>
              </div>
            </Accordion.Content>
          </Accordion.Item>
        </Accordion.Root>

        <Accordion.Root className={accordionRootClasses + "mt-5"} type="multiple">
          <Accordion.Item
            value="item-1"
            className="overflow-hidden bg-brand-slate first:mt-0 first:rounded-lg last:rounded-lg cursor-pointer w-full hover:bg-brand-slate/40"
          >
            <Accordion.Trigger
              className="
                            group flex flex-1 h-[52px] items-center 
                            justify-between px-5 text-[15px]
                            w-full mt-0
                            hover:bg-brand-slate/40"
              onClick={() => setIsQ4Open(!isQ4Open)}
            >
              <div className="flex flex-col w-[50px] items-start mr-2">
                {isQ4Open ? (
                  <span
                    className="icon-[ic--baseline-minus]"
                    style={{ width: "2rem", height: "2rem" }}
                  ></span>
                ) : (
                  <span
                    className="icon-[ic--baseline-plus]"
                    style={{ width: "2rem", height: "2rem" }}
                  ></span>
                )}
              </div>
              <div className="flex w-full">
                <p className="font-bold text-start">What services do you support?</p>
              </div>
            </Accordion.Trigger>

            <Accordion.Content
              className="
                            overflow-hidden bg-brand-slate text-[15px] text-white data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown"
            >
              <div className="flex flex-1">
                <div className="flex w-full lg:h-[40px]">
                  <Link
                    href="/services"
                    className="text-start ml-20 lg:w-[1120px] w-[80%] text-white underline mt-1"
                    target="_blank"
                  >
                    You can read a full list of services and features here!
                  </Link>
                </div>
              </div>
            </Accordion.Content>
          </Accordion.Item>
        </Accordion.Root>

        <Accordion.Root className={accordionRootClasses + "mt-5"} type="multiple">
          <Accordion.Item
            value="item-1"
            className="overflow-hidden bg-brand-slate first:mt-0 first:rounded-lg last:rounded-lg cursor-pointer w-full hover:bg-brand-slate/40"
          >
            <Accordion.Trigger
              className="
                            group flex flex-1 lg:h-[52px] h-[80px] items-center 
                            justify-between px-5 text-[15px]
                            w-full mt-0
                            hover:bg-brand-slate/40"
              onClick={() => setIsQ5Open(!isQ5Open)}
            >
              <div className="flex flex-col w-[50px] items-start mr-2">
                {isQ5Open ? (
                  <span
                    className="icon-[ic--baseline-minus]"
                    style={{ width: "2rem", height: "2rem" }}
                  ></span>
                ) : (
                  <span
                    className="icon-[ic--baseline-plus]"
                    style={{ width: "2rem", height: "2rem" }}
                  ></span>
                )}
              </div>
              <div className="flex w-full">
                <p className="font-bold text-start">Is Redact safe to use?</p>
              </div>
            </Accordion.Trigger>

            <Accordion.Content
              className="
                            overflow-hidden bg-brand-slate text-[15px] text-white data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown"
            >
              <div className="flex flex-1">
                <div className="flex w-full">
                  <p className="text-start ml-20 lg:w-[1120px] w-[70%]">
                    Redact is a privacy first company. That means we collect as little of your data
                    as possible, and anonomize data related to your account. We ensure that no one -
                    not even Redact - can view any of your content that you manage in the Redact
                    app.
                  </p>
                </div>
              </div>
            </Accordion.Content>
          </Accordion.Item>
        </Accordion.Root>
      </div>
      <div className="mt-20" />
    </>
  );
};

export default FAQPersonalPricing;
